import type { ReactNode } from '@tanstack/react-router';
import type { FC, HTMLAttributes } from 'react';

export const MobileScreen: FC<HTMLAttributes<HTMLDivElement> & { nav?: ReactNode }> = ({ className, nav, children, ...props }) => {
	return (
		<div className="h-full">
			{nav}
			<div className="safe-area-h">
				<div className={`mx-auto h-full max-w-screen-sm p-6 ${className ?? ''}`} {...props}>
					{children}
				</div>
			</div>
		</div>
	);
};
